module.exports = __webpack_public_path__ + "assets/svg/arrow-r.svg";